import { isEmpty } from "lodash";

export const isFloatOrInteger = number_string => {
  const regex = new RegExp(/^[0-9]+\.[0-9]+$|^[0-9]+$/gm);
  return regex.test(number_string) || isEmpty(number_string);
};
